const sourceType = {
  DEPOT_GATE_ID: 1,
  VENDOR_GATE_ID: 2,
};

const hubType = {
  TRANSPORTER_HUB: 1,
};

const hubTypeMap = {
  'transporter hub': 'TRANSPORTER_HUB',
}

const transshipmentConstants = {
  validTransshipmentHeaders: {
    'Source Id': 'source_id',
    'Hub Id': 'hub_id',
    'Hub Type': 'hub_type',
  },
};

module.exports = {
  sourceType,
  hubType,
  hubTypeMap,
  transshipmentConstants,
};
